import { AddQBankStructureNoRowOverlay } from '../../components';
import { useQConfigGeneratorCreationForm } from '../../providers';
import { QBankStructureSettingSection } from '../qbank-structure-setting-section';

interface QBankStructureSettingSectionGroupProps {
  openAddQBankToQConfigGeneratorModal: () => void;
}

export default function QBankStructureSettingSectionGroup(
  props: Readonly<QBankStructureSettingSectionGroupProps>,
) {
  const { openAddQBankToQConfigGeneratorModal } = props;
  const formContext = useQConfigGeneratorCreationForm();
  const qBankStructure = formContext.watch('qbank');

  if (!qBankStructure || qBankStructure.length === 0) {
    return <AddQBankStructureNoRowOverlay onClick={openAddQBankToQConfigGeneratorModal} />;
  }

  return qBankStructure.map((qBankStructure, index) => (
    <QBankStructureSettingSection
      key={qBankStructure.qbankSelection?.value ?? `qbank-${index}`}
      qBankStructure={qBankStructure}
    />
  ));
}
